import Entity from 'utilities/Entity';

class Events extends Entity {}

export default new Events();
